export default "__VITE_ASSET__9751e67c__"